import { ref } from 'vue'
import { useApi } from '@/functions/api'

export function useProductMultiplierList () {
  const api = useApi()
  const productMultipliers = ref<ProductMultiplier[]>([])
  const pagination = ref<Pagination>()
  const loading = ref(false)

  const getData = async (params = {}) => {
    try {
      loading.value = true
      const response = await api.GET<ApiCollection<ProductMultiplier>>('admin/product-price-multiplier', params)
      productMultipliers.value = response.data
      pagination.value = response.meta
    } finally {
      loading.value = false
    }
  }

  return {
    getData,
    loading,
    productMultipliers,
    pagination,
  }
}

export function useProductMultiplierEdit () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})
  const multiplier = ref(0)

  const submitForm = async (id: number) => {
    try {
      submitting.value = true
      return await api.PUT<ProductMultiplier>(`admin/product-price-multiplier/${id}`, {
        multiplier: multiplier.value,
      })
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    multiplier,
    errors,
    submitting,
    submitForm,
  }
}
